import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { ExternalIntegrationInstallButton } from 'modules/marketplace/components/Item/InstallWorkflow/ExternalIntegrationInstallButton'
import { InternalIntegrationInstallationButton } from 'modules/marketplace/components/Item/InstallWorkflow/InternalIntegrationInstallationButton'

interface InstallationButtonInterface {
  integration: ItemIntegrationFragment
}

export const InstallationButton = ({ integration }: InstallationButtonInterface) => {
  return integration.installable ? (
    <InternalIntegrationInstallationButton integration={integration} />
  ) : (
    <ExternalIntegrationInstallButton integration={integration} />
  )
}
